import React from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { FormSpy } from "react-final-form";

import { Button, Typography } from "@material-ui/core";

import FormControl, {
  TextFieldControl,
  UploadPreviewFieldControl,
} from "components/FormControl";
import SubmitButtonControl from "components/FormControl/SubmitButtonControl";
import LoadingButton from "components/LoadingButton";
import Row from "components/Form/Row";

import {
  compose,
  lengthValidator,
  imageTypesValidator,
  fileSizeValidator,
  imageIsCorruptedValidator,
} from "utils/validators";

import { ACCEPTED_IMAGE_TYPES } from "constants/image";

import { Container, Buttons, ButtonContainer } from "./styles";

type FormSubmitData = {
  values: any;
};

type Props = {
  isLoading: boolean;
  onClose: () => void;
  onChangeIsDirty: (params: { dirty: boolean }) => void;
  onSubmit: (data: FormSubmitData) => void;
  initialValues?: any;
};

const MAX_FILE_SIZE_IN_MB = 1;

@observer
class EquipmentForm extends React.Component<Props> {
  get isEditMode() {
    const { initialValues } = this.props;
    return !!initialValues;
  }

  get formTitle() {
    return !this.isEditMode ? "Add Equipment" : "Edit Equipment";
  }

  @computed get initialValues() {
    const { initialValues } = this.props;

    return this.isEditMode ? initialValues : {};
  }

  formFileValidator = (acceptedTypes: string) => (value?: File) =>
    imageTypesValidator(value?.type ?? "", acceptedTypes);

  render() {
    const { onClose, onSubmit, onChangeIsDirty } = this.props;

    return (
      <FormControl onSubmit={onSubmit} initialValues={this.initialValues}>
        <FormSpy subscription={{ dirty: true }} onChange={onChangeIsDirty} />
        <Container>
          <Row>
            <Typography variant="h1" color="textPrimary">
              {this.formTitle}
            </Typography>
          </Row>

          <Row>
            <TextFieldControl
              variant="outlined"
              margin="none"
              label="Title"
              name="title"
              placeholder="Enter title"
              validate={lengthValidator(100)}
              fullWidth
              required
            />
          </Row>

          <Row>
            <UploadPreviewFieldControl
              name="file"
              title="Icon"
              acceptedFiles={ACCEPTED_IMAGE_TYPES}
              validate={compose(
                this.formFileValidator(ACCEPTED_IMAGE_TYPES),
                fileSizeValidator(MAX_FILE_SIZE_IN_MB),
                imageIsCorruptedValidator,
              )}
              required
            />
          </Row>
        </Container>

        <Buttons>
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonContainer>
          <ButtonContainer>
            <SubmitButtonControl render={this.renderButton} />
          </ButtonContainer>
        </Buttons>
      </FormControl>
    );
  }

  renderButton = ({ onClick }: { onClick: () => void }) => (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      color="primary"
      isLoading={this.props.isLoading}
      fullWidth
    >
      {!this.isEditMode ? "Add" : "Save"}
    </LoadingButton>
  );
}

export default EquipmentForm;
